import { createGlobalStyle } from 'styled-components';

// Color generator:
// - https://coolors.co/e0acd5-3993dd-414141-f4ebe8-29e7cd
const GlobalStyle = createGlobalStyle`
  html {  
    // Because Semantic UI uses 'rem' we can change this
    // to change the whole website font size.
    //
    // The default is 14px.
    // font-size: 17px;
  }

  body {
    color: #333;
    font-family: "Merriweather","PT Serif",Georgia,"Times New Roman",serif;

    // set in "body" not "html" because otherwise Safari doesn't support
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  html, body {
    // remove Semantic setting this...it ruins the ability to set margins
    height: unset;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "Lato","Helvetica Neue",Helvetica,sans-serif;
    font-weight: 900;
    line-height: 1.25;
    margin-top: 1em;
    margin-bottom: 0.5em;
    font-size: 2.2rem;
  }

  .ui.text.container, p {
    font-size: 1.4rem;
    line-height: 1.5;
    font-family: "Merriweather","PT Serif",Georgia,"Times New Roman",serif;
  }

  a, a:hover {
    color: #4183c4;
    text-decoration-line: underline;
  }

  a:hover {
    color: #000a13;
  }
}`;

export default GlobalStyle;
